import { createSelector } from 'reselect';

export const isAddDisabled = state => state.getIn(['slip', 'addDisabled']);
export const getSlips = state => state.getIn(['slip', 'entities']);
export const getSlip = (state, { slipId }) => state.getIn(['slip', 'entities', slipId]);

export const getSlipIds = createSelector(getSlips, slips => slips.keySeq().toArray());
